import { axiosInstance } from '../Middleware'
import { Authentification } from './types'

export class AuthentificationApi {
  // Appel d'authentification pour récupérer les tokens
  public static async login(email: string, password: string): Promise<Authentification> {

    const data = {
      username: email,
      password: password
    }

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }
    const res = await axiosInstance.post('personnel/personnel/signin', data, config)

    return res.data
  }
}